module.exports = __SPARKY_LIBS__.lodash.isEmpty;